<template>
  <a-dialog
    ref="dialog"
    size="large"
    :persistent="false"
    :toolbar="true"
    :actions="false"
    name="serp_detail"
    :loading="loading"
    @open="opened"
    @close="$reset">
    <span slot="title" v-if="serp">
      <serp-dialog-title :serp="serp"></serp-dialog-title>
    </span>
    <div slot="content">
      <div>
        <div class="mt-4 mb-4">
          <v-tabs v-if="$vuetify.breakpoint.mdAndUp" v-model="tab.active">
            <v-tab>Analyse</v-tab>
            <v-tab>Source d'analyse</v-tab>
            <v-tab>Log d'analyse</v-tab>
            <v-tab>Source HTML</v-tab>
          </v-tabs>
          <v-select solo hide-details class="ml-4 mr-4" v-else v-model="tab.active" :items="tab.items"></v-select>
        </div>
      </div>
      <v-tabs-items v-model="tab.active">
        <v-tab-item>
          <serp-dialog-detail-table
            v-if="serp"
            :serp="serp">
          </serp-dialog-detail-table>
        </v-tab-item>
        <v-tab-item>
          <v-jsoneditor
            v-if="rawSerp && rawSerp.debug"
            v-model="rawSerp.items"
            :plus="false"
            height="560px"
            :options="{mode: 'code', mainMenuBar: false, navigationBar: false, statusBar: false}">
          </v-jsoneditor>
        </v-tab-item>
        <v-tab-item>
          <pre v-if="rawSerp && rawSerp.debug">{{ rawSerp.debug.log }}</pre>
        </v-tab-item>
        <v-tab-item>
          <iframe
            ref="iframe"
            src="about:blank"
            scrolling="no"
            :style="'height: ' + iframe.height + '; border: 0; width: ' + iframe.width + ';'">
          </iframe>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </a-dialog>
</template>

<script>
import { get } from 'lodash'
import SerpDialogDetailTable from '@/views/Common/Components/SerpDetail/SerpDialogDetailTable'
import SerpDialogTitle from '@/views/Common/Components/SerpDetail/SerpDialogTitle'

export default {
  name: 'CrawlerInspectionDetailsDialog',
  components: {
    SerpDialogTitle,
    VJsoneditor: () => import('v-jsoneditor/src/index'),
    SerpDialogDetailTable
  },
  data () {
    return {
      loading: '',
      serp: null,
      rawSerp: null,
      carrier: {},
      tab: {
        active: 0,
        items: [
          { text: 'Analyse', value: 0 },
          { text: 'Source d\'analyse', value: 1 },
          { text: 'Log d\'analyse', value: 2 },
          { text: 'Source HTML', value: 1 },
        ]
      },
      iframe: {
        height: 0,
        width: 0,
      }
    }
  },
  watch: {
    'tab.active' (value) {
      if (value === 3) {
        setTimeout(() => {
          this.setIframeSource(this.rawSerp.debug.html)
        }, 500)
      }
    }
  },
  methods: {
    async opened ({ hash, id }) {
      this.loading = 'Chargement ...'

      try {
        this.rawSerp = (await this.$carrier.get('crawler/inspection/' + hash + '/' + id + '.json')).data
        this.serp = this.$models.serp.get(this.rawSerp)
      } catch (e) {
        if (get(e, 'response.status') === 404) {
          this.$ui.warning('Une erreur est survenue lors de la récupération des données. Merci de tenter à nouveau dans quelques instants.')
        } else {
          this.$ui.error('Une erreur est survenue : ' + e)
        }
        if (this.$refs.dialog) this.$refs.dialog.close()
      } finally {
        this.loading = ''
      }
    },
    setIframeSource (source) {
      const iframe = this.$refs.iframe.contentWindow.document
      let data = source
      data = data.replace('src="/', 'src="https://www.google.com/')
      iframe.open()
      iframe.write(data)
      iframe.close()

      this.iframe.height = iframe.body.scrollHeight + 'px'
      this.iframe.width = iframe.body.scrollWidth + 'px'
    }
  }
}
</script>

<style scoped>

</style>